import styles from "./paymentwidgetcard.module.css";
import dayjs from "dayjs";
import { Check, Clock, CreditCard, XCircle } from "react-feather";
import { DashCardLoaderSmall3 } from "../../../../../../../components/LoaderC";

const PaymentWidgetCard = ({ rentRollData, contentLoading }) => {

    return (<div className={`${styles.RentrollCardRow}`}>
        <div className={`${styles.RentrollScoreCard} ${styles.Bill}`}>
            {contentLoading && (<div><DashCardLoaderSmall3 /></div>)}
            {!contentLoading && <>
                <div className={`${styles.Icon}`}><CreditCard /></div>
                <span className={`${styles.StatusBadge} ${styles.Blue}`}>{dayjs().format('MMM YYYY')}</span>
                <p className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(rentRollData?.current_month_data?.bill_amount)}</p>
                <p className={`${styles.Text}`}>Total Billed</p>
            </>}
        </div>
        <div className={`${styles.RentrollScoreCard} ${styles.collected}`}>
            {contentLoading && (<div><DashCardLoaderSmall3 /></div>)}
            {!contentLoading && <>
                <div className={`${styles.Icon}`}><Check /></div>
                <span className={`${styles.StatusBadge} ${styles.Green}`}>{rentRollData?.current_month_data?.collected_percentage}%</span>
                <p className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(rentRollData?.current_month_data?.collected_amount)}</p>
                <p className={`${styles.Text}`}>Total Collected</p>
            </>}
        </div>
        <div className={`${styles.RentrollScoreCard} ${styles.outstanding}`}>
            {contentLoading && (<div><DashCardLoaderSmall3 /></div>)}
            {!contentLoading && <>
                <div className={`${styles.Icon}`}><Clock /></div>
                <span className={`${styles.StatusBadge} ${styles.Yellow}`}>{rentRollData?.current_month_data?.due_bill} bill</span>
                <p className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(rentRollData?.current_month_data?.balance_amount)}</p>
                <p className={`${styles.Text}`}>Outstanding</p>
            </>}
        </div >
        <div className={`${styles.RentrollScoreCard} ${styles.failed}`}>
            {contentLoading && (<div><DashCardLoaderSmall3 /></div>)}
            {!contentLoading && <>
                <div className={`${styles.Icon}`}><XCircle /></div>
                <span className={`${styles.StatusBadge} ${styles.Red}`}>{rentRollData?.current_month_data?.failed_transaction} txn</span>
                <p className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(rentRollData?.current_month_data?.failed_amount)}</p>
                <p className={`${styles.Text}`}>Failed</p>
            </>}
        </div>
    </div >);
}

export default PaymentWidgetCard;